import reportsConfig from '~/constants/data-reports/lithium-ion-batteries'

const lithiumIonBatteriesData = {
  hero: reportsConfig.hero,
  brochureFile: {
    EnvKey: 'lithiumIonBatteriesPriceAssessmentsMethodologyId',
    category: 'methodology-price-assessments',
    file_name:
      'Benchmark-Lithium-Ion-Batteries-Cells-Price-Assessment-Methodology.pdf',
  },
  descriptions: [
    'With over 1.5 TWh of lithium ion battery cell production capacity installed as of 2022, the battery cell market continues to grow on a global scale.',
    'Benchmark’s Lithium ion Cell Price Assessment covers all 7 major chemistries across all formats in each major region, providing transparency within the downstream supply chain.',
    'Understanding the intricacies of cell pricing allows those involved in the market to accurately and confidently budget for cell purchasing, benchmark against competitors, and see behind the numbers in company financials.',
  ],
  services: [
    {
      icon: 'services/icon-chart-line',
      description:
        'Create your own custom pricing charts using our bespoke data.',
    },
    {
      icon: 'services/icon-presentation',
      description:
        'Produce custom made representations of data to download for projects and presentations.',
    },
    {
      icon: 'services/icon-consultancy',
      description:
        'Access Benchmark’s exclusive industry commentary collected through our extensive network of industry contacts.',
    },
    {
      icon: 'services/icon-idea',
      description:
        'Our goal is to help you understand the context of our data, not just give you the numbers.',
    },
  ],
  indexTab: true,
  requiredFilters: ['categories', 'shippingRoutes', 'formats', 'priceTypes'],
}
export default lithiumIonBatteriesData
